// extracted by mini-css-extract-plugin
export default {"email":"style_email__qsGdx"};